import {createSelector} from 'reselect'

import {STRIPE_PAYMENTS} from '../../../../../common/constants/Integrations.js'
import {locationSelector} from '../../location.js'
import {
  PAYMENTS,
  SETTINGS,
} from '../../../../../common/constants/SettingsPanels.js'

export const editIDSelector = createSelector(
  locationSelector,
  ({pathComponents}) => {
    if (
      pathComponents[0] === SETTINGS &&
      pathComponents[1] === PAYMENTS &&
      pathComponents[2]
    ) {
      return pathComponents[2]
    }
  },
)

export function paymentIntegrationOptionsSelector() {
  return [{value: STRIPE_PAYMENTS, display: 'Stripe'}]
}
